import React from "../../__compat__/react/main.entry.mjs.mjs";
import { audiLightTheme } from "../../themes/index.mjs.mjs";
import { ThemeProvider } from "../ThemeProvider/index.mjs.mjs";
/**
 * @deprecated Use `ThemeProvider` directly.
 */
export const AudiPlatformProvider = ({ theme = audiLightTheme, children }) => (React.createElement(ThemeProvider, { theme: theme }, children));
//# sourceMappingURL=PlatformProvider.mjs.mjs.map